import { render } from "./SortAlphabeticalDescending.vue?vue&type=template&id=30be675c"
import script from "./SortAlphabeticalDescending.vue?vue&type=script&lang=js"
export * from "./SortAlphabeticalDescending.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__